// extracted by mini-css-extract-plugin
module.exports = {"section":"cf_l","locationsList":"cf_g7"};